export enum IncentiveMode {
  CountryView = 'country',
  List = 'list',
  Comparison = 'comparison',
  Detail = 'detail',
  Export = 'export'
}
